import { SkeletonTable } from "@/components/ui/Skeleton";
import type { PucCuenta } from "@/api/empresas";

interface PucTableProps {
  cuentas: PucCuenta[];
  isLoading: boolean;
  search: string;
  onEdit: (cuenta: PucCuenta) => void;
  onDelete: (cuenta: PucCuenta) => void;
}

export const PucTable = ({
  cuentas,
  isLoading,
  search,
  onEdit,
  onDelete,
}: PucTableProps) => {
  const filtered = cuentas.filter(
    (c) =>
      !search ||
      c.codigo_puc.toLowerCase().includes(search.toLowerCase()) ||
      c.nombre_cuenta.toLowerCase().includes(search.toLowerCase()),
  );

  if (isLoading) {
    return (
      <div className="overflow-hidden rounded-lg border border-slate-200">
        <table className="min-w-full divide-y divide-slate-200 text-sm">
          <tbody>
            <tr>
              <td colSpan={4} className="px-4 py-4">
                <SkeletonTable rows={6} cols={4} />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <div className="overflow-hidden rounded-lg border border-slate-200">
      <table className="min-w-full divide-y divide-slate-200 text-sm">
        <thead className="bg-slate-50 text-left text-xs uppercase tracking-wide text-ink-secondary">
          <tr>
            <th className="px-4 py-2">PUC</th>
            <th className="px-4 py-2">Cuenta</th>
            <th className="px-4 py-2 text-right">% Retención</th>
            <th className="px-4 py-2" />
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-100">
          {filtered.length === 0 ? (
            <tr>
              <td colSpan={4} className="px-4 py-4 text-center text-ink-secondary">
                {cuentas.length === 0
                  ? "Sin cuentas PUC registradas para esta empresa."
                  : "Sin resultados para la búsqueda."}
              </td>
            </tr>
          ) : (
            filtered.map((c) => (
              <tr key={c.id} className="hover:bg-slate-50">
                <td className="px-4 py-2 num-font font-medium">{c.codigo_puc}</td>
                <td className="px-4 py-2 text-ink-secondary">{c.nombre_cuenta}</td>
                <td className="px-4 py-2 text-right num-font">
                  {c.porcentaje_retencion ? `${c.porcentaje_retencion}%` : "—"}
                </td>
                <td className="px-4 py-2 text-right">
                  <button
                    type="button"
                    onClick={() => onEdit(c)}
                    className="text-xs font-medium text-accent-blue hover:underline"
                  >
                    Editar
                  </button>
                  <button
                    type="button"
                    onClick={() => onDelete(c)}
                    className="ml-3 text-xs font-medium text-accent-red hover:underline"
                  >
                    ×
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};